export enum LoopState {
  Running = 'running',
  Paused = 'paused',
  Completed = 'completed'
}